import { FunctionComponent, ReactNode } from "react";
import { cn } from "../../utils/cn";

export interface SingleColumnLayoutProps {
  className?: string;
  children: ReactNode;
}

/**
 *
 */
const SingleColumnLayoutRoot: FunctionComponent<SingleColumnLayoutProps> = ({
  className,
  children,
}) => {
  const css = cn(className, "flex flex-col gap-8");
  return <div className={css}>{children}</div>;
};

export const SingleColumnLayout = Object.assign(SingleColumnLayoutRoot, {});
